"use client";
import { useState, useEffect, Suspense } from 'react'
import style from './page.module.css';
import CoinPopup from '../component/coinpopup/CoinPopup';
import RewardRule from '../component/coinpopup/RewardRule';
import { useAuthStore } from '../store/authstore';
import { useRouter, useSearchParams } from 'next/navigation';
import LoginPopup from '../component/coinpopup/LoginPopUp';
import TaskList from './TaskList';
import Streak from './Streak';
import CoinBalance from './CoinBalance';
import { useRemoteConfigStore } from '../store/remoteConfigStore';


function RewardsContent() {
    const config = useRemoteConfigStore((s) => s.config);
    const [infoPopupOpen, setInfoPopupOpen] = useState(false);
    const user = useAuthStore((s) => s.user);
    const searchParams = useSearchParams();
    const router = useRouter();
    const [popupAmount, setPopupAmount] = useState<number | null>(null);

    useEffect(() => {
        try {
            if (searchParams && searchParams.get('init') === 'welcome') {
                const amt = Number(searchParams.get('amount') || String(config.welcomeBonus));
                setPopupAmount(amt);
                setTimeout(() => setPopupAmount(null), 1000);// auto-hide popup after 1s
                try { router.replace('/rewards'); } catch { /* ignore */ }
            }
        } catch {
            // ignore
        }
    }, [searchParams, router]);



    return (
        <div className={style.dfx_coinSec}>

            <div className={style.dfx_coinTitle}>
                <h2>Earn Coin</h2>
                <p>Earn coins by completing the tasks. Use your coins to unlock episodes.</p>
            </div>
            <div className={style.dfx_coinMainContainer}>
                <div className={style.dfx_coinContent}>
                    <CoinBalance/>
                    <Streak values={config} onAward={(amt: number) => {
                        setPopupAmount(amt);
                        setTimeout(() => setPopupAmount(null), 3000);
                    }} />
                </div>
                <h3 className={style.dfx_coinTaskTitle}>Earn Coins by Completing Tasks</h3>
                <div className={style.dfx_coinTaskContent}>
                    <TaskList values={config} onAward={(amt: number) => {
                        setPopupAmount(amt);
                        setTimeout(() => setPopupAmount(null), 3000);// auto-hide popup after 3s
                    }} />
                </div>

                {/* Popup overlay components below*/}
                {popupAmount && <CoinPopup amount={popupAmount} />}

                {infoPopupOpen && <RewardRule onClose={() => setInfoPopupOpen(false)} />}

                {(user && user.user_email) ? null : <LoginPopup />}

            </div>
        </div>
    )
}

export default function Rewards() {
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <RewardsContent />
        </Suspense>
    );
}
